import type {
  ClientResponse,
  ServerResponse,
} from '@onhandtech/onhand-fe-shared/lib/api/v4/file/post'
import {
  handleFailure,
  handleSuccess,
  moduleName,
} from '@onhandtech/onhand-fe-shared/lib/api/v4/file/post'
import { createReduxServiceModule } from '@onhandtech/onhand-fe-shared/lib/redux'
import type { RequestArgs } from '@onhandtech/onhand-fe-shared/lib/request'
import { formatEndpoint } from '@onhandtech/onhand-fe-shared/lib/request'

import { getConfig } from '../../../../../config/configuration'

const args: RequestArgs<ServerResponse, ClientResponse> = {
  method: 'POST',
  url: formatEndpoint(getConfig().endpoints.api.v4.file),
  requestConfig: {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  },
  handleSuccess,
  handleFailure,
}

const postFileModule = () => createReduxServiceModule({ moduleName, args })

export default postFileModule
